import state from './moduleDigitalApplicationState.js'
import mutations from './moduleDigitalApplicationMutations.js'
import actions from './moduleDigitalApplicationActions.js'
import getters from './moduleDigitalApplicationGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
